import React, { PropsWithChildren } from 'react';

import { AdjustVolumeByClick } from './AdjustVolumeByClick';
import { BrightcovePlayerStylesWrapper } from './elements';
import { HideVolumeButtonOnMobile } from './HideVolumeButtonOnMobile';
import { PlayerLoader } from './PlayerLoader';
import { PosterBackdrop } from './PosterBackdrop';
import { Rewind10SecButton } from './Rewind10SecButton';
import { VolumeHotkeys } from './VolumeHotkeys';
import { useMediaPlayer } from '../MediaPlayerProvider';

/*
 * MediaPlayerBase loads the player and enables all cross-players features.
 * It should be used as a base to build all other player.
 * If you want to add common feature to all player, do it here.
 */
export const MediaPlayerBase: React.FC<PropsWithChildren> = ({ children }) => {
  const { player } = useMediaPlayer();

  // syncronize react lifecycle and videojs state
  const isPlayerReady = player !== null;

  return (
    <BrightcovePlayerStylesWrapper ready={isPlayerReady}>
      <PlayerLoader>
        <VolumeHotkeys />
        <Rewind10SecButton />
        <PosterBackdrop />
        <HideVolumeButtonOnMobile />
        <AdjustVolumeByClick />
        {children}
      </PlayerLoader>
    </BrightcovePlayerStylesWrapper>
  );
};
